import React from 'react'
import plusIcon from "../assets/icons/plusIcon.png"

const AddInput = ({onClick}) => {
  return <>
      <img src={plusIcon} className='cursor-pointer' onClick={onClick} alt="plusIcon" />
  </>
}

export default AddInput